import TChannelList from '../templates/channelList';
import { useAppSelector } from '../../../shared/store/hooks';
import { channelsSelector } from '../../../shared/store/slices/channels.slice';
import { eventsSelector } from '../../../shared/store/slices/events.slice';

export default function ChannelList() {
  const { currentEvents } = useAppSelector(eventsSelector);
  const { currentChannel, favouriteChannels } =
    useAppSelector(channelsSelector);
  const currentIndex =
    favouriteChannels?.findIndex((item) => item.id === currentChannel?.id) || 0;

  return (
    <>
      {favouriteChannels?.length && (
        <TChannelList
          channelsData={favouriteChannels}
          currentChannel={currentChannel}
          currentEvents={currentEvents}
          currentIndex={currentIndex}
          pop
        />
      )}
    </>
  );
}
